import { ToastProvider } from '@zillow/constellation-10';
import { Auth, MfaStepUpBoundary } from '@common/auth/AuthProvider';
import AppContainer from './container';

// MFA auth gating is a browser-only concern: the server enforces auth in the
// `authenticate` middleware and renders the app bare. `__BROWSER__` keeps the
// boundary out of the SSR tree (it short-circuits to the bare app on the server).
// TODO: properly prefetch state before rendering so auth components render during SSR
export default function RentalManagerApp() {
  return __BROWSER__ ? (
    <Auth.Provider>
      <MfaStepUpBoundary>
        <ToastProvider>
          <AppContainer />
        </ToastProvider>
      </MfaStepUpBoundary>
    </Auth.Provider>
  ) : (
    <ToastProvider>
      <AppContainer />
    </ToastProvider>
  );
}
